/* eslint-disable no-unused-vars */

import React, { useContext, useEffect, useState } from "react";
import {
  changeCardStatus,
  DeletCollbrate,
  deleteUserCard,
  getAllCardsService,
} from "../../services/cardService";
import { ClipLoader } from "react-spinners";
import {
  getAllCollectionsPublicService,
  getAllCollectionsPublicServiceActive,
  getCollabrate,
  getLikes,
} from "../../services/collectionsService";
import ColllectionsCard from "../Home/ColllectionsCard";
import { Link } from "react-router-dom";

import Swal from "sweetalert2";
import { rootContext } from "../../context/RootContext";
import AvailableCollections from "../Collection/AvailableCollections";
import useSubscription from "../../hooks/useSubscription";
import AvailableSubCollections from "../Collection/AvailableSubCollections";
import ColllectionsCollabrate from "../Home/ColllectionsCollabrate";
import AvailableCollabrate from "../Collection/AvailableCollabrate";
import AvailableSubCollabrate from "../Collection/AvailableSubCollabrate";
import { axiosInstance } from "../../utils/axiosHelper";
import AvailableChapterForCollabrate from "../Collection/AvailableChapter";
export default function MyCollabrate() {
  const { setSelectedTabIndex, setUpdateCardData, setGlobalUrl } =
    useContext(rootContext);
  const [data, setData] = useState([]);
  const [likes, setlike] = useState([]);
  const [url, setUrl] = useState("");
  const [loader, setLoader] = useState(true);
  const { isSubscribed } = useSubscription();
  const userId = JSON.parse(localStorage.getItem("user"));
  const allCollectionsData = async () => {
    setLoader(true);
    const result = await getCollabrate();
    if (result) {
      setData(result?.card);
      // console.log(result?.imagePath)
      setLoader(false);
      setUrl(result.imagePath);
    } else {
      setLoader(false);
    }
  };
  // const allLikes = async () => {
  //   setLoader(true);
  //   const result = await getLikes();
  //   if (result) {
  //     setlike(result);
  //     // console.log(result?.imagePath)
  //     setLoader(false);
  //   } else {
  //     setLoader(false);
  //   }
  // };
  useEffect(() => {
    allCollectionsData();
    // allLikes();
  }, []);

  // delete card start
  const openDeleteConfirmModal = async (id) => {
    // alert(row.original.id)

    Swal.fire({
      title: "Do you want to Delete a Application",
      showCancelButton: true,
      confirmButtonText: "Delete",
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoader(true);

        const reuslt = await deleteUserCard(id);
        if (reuslt.cardCollectionTitle) {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Application has been deleted successfully.",
          });
          setLoader(false);
        } else {
          // setIsUpdatingUser(false);
          // setIsLoadingUsers(false);
          allCollectionsData();
          setLoader(false);
        }
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };
  // delete card end
  // change status start
  const handleStatusCollection = async (id, status) => {
    console.log("the status is", status);
    const statusValue = status === 0 ? 1 : 0;
    setLoader(true);
    const result = await changeCardStatus(statusValue, id);
    console.log(result.card);
    if (result.card) {
      allCollectionsData();
      setSelectedTabIndex(1);
      setLoader(false);
    } else {
      setLoader(false);
    }
  };
  const editCard = (data) => {
    setUpdateCardData(data);
    setSelectedTabIndex(3);
    setGlobalUrl(url);
  };
  // change status end
  useEffect(() => {
    allCollectionsData();
  }, []);
  const deleteFnc = async (id) => {
    const result = await DeletCollbrate(id);
    console.log(result);
    if (result?.message) {
      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: result?.data?.message,
      });
      allCollectionsData();
      setLoader(false);
    }
  };

  return (
    <div>
      {!loader ? (
        <div className="New Collections">
          {data?.length === 0 ? (
            <h2>No Collabrate Found</h2>
          ) : (
            <h2> My Collabrate</h2>
          )}
          {isSubscribed === null ? (
            <p>
              - You have not subscribe to any collection. When you subscribe to
              a collection it will be displayed here.
            </p>
          ) : null}
          <div className="row">
            {data?.length > 0 &&
              data?.slice(0, 8)?.map((item, index) => (
                <div class=" col-lg-4 col-md-6 col-sm-6 col-xs-12">
                  {/* <Link to={`/collection/${item.slug}`}> */}
                  <ColllectionsCollabrate
                    src={`${url}${item?.card_images?.[0].image}`}
                    name={item.name}
                    data={item}
               
                    iscollabrate={true}
                    user={userId}
                    deleteFnc={deleteFnc}
                  />
                  {/* </Link> */}
                </div>
              ))}
          </div>
          <div className="pt-4">
            <AvailableCollabrate />
          </div>

          <div className="pt-4">
            <AvailableSubCollabrate />
          </div>
          <div className="pt-4">
            <AvailableChapterForCollabrate />
          </div>
        </div>
      ) : (
        <div className="vh-50 d-flex justify-content-center align-items-center">
          <ClipLoader loading={loader} color="#333" size={50} />
        </div>
      )}
    </div>
  );
}
